export const sliderImages = [
  {
    sliderImage: "/images/happyWithFriends.jpg",
    alt: "friends",
    data: "친구 등록하기",
    label: "친구 등록하기",
    details: "직관을 보러 갈 친구들을 서로 등록할 수 있습니다.",
    link: "/sub",
  },
  {
    sliderImage: "/images/baseball-stadium.webp",
    alt: "stadium",
    data: "구장 예약하기",
    label: "구장 예약하기",
    details: "직관을 보러 갈 구장을 예약할 수 있습니다.",
    link: "/reservation",
  },
  {
    sliderImage: "/images/batter.jpg",
    alt: "subcribe",
    data: "구독하기",
    label: "구단별 구독 시스템 구독하기",
    details: "각 구단의 예약 시스템을 구독할 수 있습니다.",
    link: "/sub",
  },
  {
    sliderImage: "/images/sample.jpg",
    alt: "community",
    data: "커뮤니티 이동",
    label: "커뮤니티 이동",
    details: "여러 커뮤니티 활동이 가능합니다.",
    link: "/community",
  },
];
